import React, { useState } from 'react';
import { MessageCircle, Mail, MapPin, Plus, X } from 'lucide-react';
import { COMPANY } from '../mock/data';
import GoogleLogo from './GoogleLogo';

const FloatingButtons = () => {
  const [open, setOpen] = useState(false);

  const buttons = [
    {
      key: 'whatsapp',
      label: 'WhatsApp',
      href: `https://wa.me/${COMPANY.whatsapp}`,
      icon: MessageCircle,
      bg: 'bg-[#25D366]',
      hover: 'hover:bg-[#1ebe57]',
      pulse: 'btn-pulse-green',
    },
    {
      key: 'mail',
      label: 'E-Mail',
      href: `mailto:${COMPANY.email}`,
      icon: Mail,
      bg: 'bg-brand-blueDark',
      hover: 'hover:bg-brand-blue',
      pulse: 'btn-pulse-blue',
    },
    {
      key: 'google',
      label: 'Google Maps',
      href: COMPANY.googleMaps,
      icon: MapPin,
      bg: 'bg-[#4285F4]',
      hover: 'hover:bg-[#3367d6]',
      pulse: 'btn-pulse-blue',
    },
  ];

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
      {open && (
        <div className="flex flex-col gap-3 mb-1 animate-in slide-in-from-bottom-2 fade-in duration-200">
          <a
            href={COMPANY.googleReviews}
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-center gap-3 bg-white text-neutral-900 rounded-full shadow-2xl pl-3 pr-5 py-3 ring-4 ring-white/30 transition-all hover:scale-105 border border-neutral-200"
            aria-label="Google Reviews"
          >
            <GoogleLogo className="w-5 h-5" />
            <span className="text-sm font-semibold whitespace-nowrap">Google</span>
          </a>
          {buttons.map((b) => {
            const Icon = b.icon;
            return (
              <a
                key={b.key}
                href={b.href}
                target="_blank"
                rel="noopener noreferrer"
                className={`group flex items-center gap-3 ${b.bg} ${b.hover} text-white rounded-full shadow-2xl pl-4 pr-5 py-3 transition-all hover:scale-105 ${b.pulse}`}
                aria-label={b.label}
              >
                <Icon className="w-5 h-5" />
                <span className="text-sm font-semibold whitespace-nowrap">{b.label}</span>
              </a>
            );
          })}
        </div>
      )}

      <button
        onClick={() => setOpen(!open)}
        className="relative w-16 h-16 rounded-full bg-brand-blue hover:bg-brand-blueDark text-white shadow-2xl shadow-brand-blue/40 flex items-center justify-center transition-transform hover:scale-110 btn-pulse-blue"
        aria-label="Kontaktoptionen"
        data-testid="floating-fab"
      >
        <span className="relative">
          {open ? <X className="w-7 h-7" /> : <Plus className="w-7 h-7" />}
        </span>
      </button>
    </div>
  );
};

export default FloatingButtons;
